export enum NotificationItemIconEnum {
  MESSAGE = 'message',
  NEWCONTACT = 'insert_emoticon',
  ALERT = 'notification_important',
  INVITATION = 'new_releases',
  TERM = 'insert_invitation',
}
